import styles from './changepassword.module.css';
import { useUnit } from "effector-react";
import { Input } from "../../../shared/ui/Input/Input";
import { CHANGE_PASSWORD_VALIDATION_SCHEMA, INPUTS_ARR } from "../models/consts";
import { $changePasswordStore, $shouldRedirect, isPending } from "../models/store";
import { FormEvent, useCallback } from 'react';
import { TChangePasswordStore } from '../models/types';
import { Spinner } from '../../../shared/ui/Spinner/Spinner';
import { checkValidate } from '../../../shared/lib/input/checkValidate';
import { Navigate } from 'react-router-dom';
import { Button } from '../../../shared/ui/Button/Button';
import {
    changePasswordInputType,
    confirmChangePassword,
    setInputValue,
    setPasswordsStore
} from '../models/events';


export function ChangePassword() {
    const {
        passwordStore,
        isLoading,
        shouldRedirect,
    } = useUnit({
        passwordStore: $changePasswordStore,
        isLoading: isPending,
        shouldRedirect: $shouldRedirect,
    });

    const handleChangeInput = useCallback((key: keyof TChangePasswordStore, value: string) => {
        setInputValue({ key, value });
    }, [])

    async function handleSubmit(event: FormEvent<HTMLFormElement>) {
        event.preventDefault();

        if (isLoading) return;

        const { validate, newObj } = await checkValidate<TChangePasswordStore>(
            passwordStore,
            CHANGE_PASSWORD_VALIDATION_SCHEMA
        )

        if (validate) {
            confirmChangePassword();
        } else {
            setPasswordsStore(newObj);
        }
    }

    const changeInputType = useCallback((
        type: React.HTMLInputTypeAttribute,
        key: keyof TChangePasswordStore,
    ) => {
        changePasswordInputType({ key, type: type === 'password' ? 'text' : 'password' });
    }, [])

    // После успешной смены пароля shouldRedirect меняется на true
    // перенаправляем на логин
    if (shouldRedirect) {
        return <Navigate to={'/login'} replace />
    }

    return (
        <form
            className={styles.changePasswordForm}
            onSubmit={handleSubmit}
        >
            {INPUTS_ARR.map(input => {
                const { inputName, label, options } = input;
                const { type, value, errorMessage } = passwordStore[inputName];

                return (
                    <Input<TChangePasswordStore>
                        key={inputName}
                        value={value}
                        name={inputName}
                        isRequired
                        type={type}
                        wrapperClassName={styles.formInputs}
                        labelText={label}
                        options={options}
                        onChange={handleChangeInput}
                        changeTypeFn={changeInputType}
                        withErrorBlock
                        withPasswordIcon
                        error={errorMessage}
                    />
                )
            })}

            <Button
                className={styles.changePasswordButton}
                type='submit'
                disabled={isLoading}
            >
				{
					isLoading
						? 	<Spinner
								size={20}
								borderSize={2}
                                color='var(--white)'
							/>
						: 'Изменить'
				}
            </Button>
        </form>
    )
}
